import DefaultProps from '../../commonTypes/defaultprops.types';
import { ButtonSizes } from '../Button/button.types';
import { StateCallBack } from 'react-multi-carousel/lib/types';
import { default as ReactCarousel } from 'react-multi-carousel';

export type changeHandlerType = (slide: number, stateCallback: StateCallBack) => void;

export interface CarouselProps extends DefaultProps {
  layout: LayoutSpec;
  autoPlay?: boolean;
  autoPlaySpeed?: number;
  showDots?: boolean;
  afterChange?: changeHandlerType;
  beforeChange?: changeHandlerType;
  showArrows?: boolean;
  draggable?: boolean;
  mobileSwipeable?: boolean;
  infinite?: boolean;
  removeArrowAtWidth?: string[];
  arrowsOutside?: boolean;
  partialVisible?: boolean;
  keyBoardControl?: boolean;
  arrowSize?: ButtonSizes;
  centerMode?: boolean;
  customTransition?: string;
  refHandler?: React.Ref<ReactCarousel>;
  arrowDelay?: number;
  ssr?: boolean;
  deviceType?: DeviceTypes;
  CustomDotComponent?: React.ReactElement;
}

export enum DeviceTypes {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

export interface LayoutItem {
  breakpoint: {
    max: number | string;
    min: number | string;
  };
  items: number;
  partialVisibilityGutter?: number;
  slidesToSlide?: number;
}

export interface ResponsiveLayoutItem {
  breakpoint: {
    max: number;
    min: number;
  };
  items: number;
  partialVisibilityGutter?: number;
  slidesToSlide?: number;
}

export interface LayoutSpec {
  [key: string]: LayoutItem;
}
